<template>
<span>
    {{ firstPart }}
    <div :class="`odr-unbreakable odr-unbreakable_color-${color}`">
        {{ lastPart }}
        <slot></slot>
    </div>
</span>
</template>

<script>
import '../styles/unbreakable.scss'
import { coloringMixin } from '../mixins/coloring'

export default {
    mixins: [coloringMixin],
    props: {
        text: {
            type: String,
            default: '',
            _descr: 'Text to append to given content',
        },
    },
    data () {
        return {
            markup: null,
        }
    },
    mounted () {
        let markup = this.$el.querySelector('[data-unbreakable-part]')

        if (markup) {
            this.markup = markup.innerText
        }
    },
    computed: {
        parts () {
            return (this.text || this.markup || '').trim().split(' ')
        },
        firstPart () {
            return this.parts.slice(0, -1).join(' ')
        },
        lastPart () {
            return this.parts.slice(-1).join(' ')
        },
    },
}
</script>
